import { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { ROUTE_PATH } from "utils/constants/routePath";
import { userService } from "apiServices";
import { Mainlayouts } from "components";
import systemRoutes from "./systemRoutes";
import SplashContainer from "containers/SplashContainer";
import LoginAdminContainer from "containers/LoginAdminContainer";
import AdminScanActivityContainer from "containers/AdminScanActivityContainer";
import LoginContainer from "containers/MemberSystem/LoginContainer";
import RegisterContainer from "containers/MemberSystem/RegisterContainer";
import ForgetPasswordContainer from "containers/MemberSystem/ForgetPasswordContainer";
import ForgetPasswordCompleteContainer from "containers/MemberSystem/ForgetPasswordCompleteContainer";
import PreRegisterContainer from "containers/PreRegisterContainer";
import PreLineAuthProductWarrantyContainer from "containers/PreLineAuthProductWarrantyContainer";
import PDPAContainer from "containers/PDPAContainer";
import CetificateLandingContainer from "containers/CetificateLandingContainer";
import ProductwarranteeNotLoginContainer from "containers/ProductWarranteeSystem/ProductwarranteeNotLoginContainer";
import ProductWarranteeNotLoginSuccessContainer from "containers/ProductWarranteeSystem/ProductWarranteeNotLoginSuccessContainer";
import ActivitiesDetailPreviewContainer from "containers/ActivitiesSystem/ActivitiesDetailPreviewContainer";
import ActivityFormAdminPreviewContainer from "containers/ActivitiesSystem/ActivityFormAdminPreviewContainer";
import ActivityFormQuizContainer from "containers/ActivitiesSystem/ActivityFormQuizContainer";
import ActivitiesFormDetailContainer from "containers/ActivitiesSystem/ActivitiesFormDetailContainer";
import ActivityFormThankContainer from "containers/ActivitiesSystem/ActivityFormThankContainer";
import ActivityFormCusPreviewContainer from "containers/ActivitiesSystem/ActivityFormCusPreviewContainer";

const Navigations = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const locationSplit = location.pathname.split("/");
    if (locationSplit.some((e) => e === "system")) {
      checkToken();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const checkToken = async () => {
    let res = await userService.POST_CHECK_TOKEN();
    if (res && res.status === 200) {
      // const locationSplit = location.pathname.split('/');
      // switch (locationSplit[locationSplit.length - 1]) {
      //   case 'register':
      //     navigate(ROUTE_PATH.SPLASH);
      //     break;
      //   default:
      //     break;
      // }
    } else {
      const locationSplit = location.pathname.split("/");
      switch (locationSplit[locationSplit.length - 1]) {
        case "login":
          navigate(ROUTE_PATH.LOGIN);
          break;
        default:
          navigate(ROUTE_PATH.SPLASH);
          break;
      }
    }
  };

  return (
    <Routes>
      <Route>
        <Route path={ROUTE_PATH.SPLASH} element={<SplashContainer />} />
        <Route path="*" element={<SplashContainer />} />
      </Route>
      <Route element={<Mainlayouts.AuthenLayout />}>
        <Route path={ROUTE_PATH.LOGIN} element={<LoginContainer />} />
        <Route path={ROUTE_PATH.REGISTER} element={<RegisterContainer />} />
        <Route
          path={ROUTE_PATH.FORGET_PASSWORD}
          element={<ForgetPasswordContainer />}
        />
        <Route
          path={ROUTE_PATH.FORGET_PASSWORD_COMPLETE}
          element={<ForgetPasswordCompleteContainer />}
        />
      </Route>
      <Route element={<Mainlayouts.PageLogoLayout />}>
        <Route
          path={ROUTE_PATH.ACTIVITY_FORM_QUIZ_NO_LOGIN}
          element={<ActivityFormQuizContainer />}
        />
        <Route
          path={ROUTE_PATH.ACTIVITY_FORM_NO_LOGIN}
          element={<ActivitiesFormDetailContainer />}
        />
        <Route
          path={ROUTE_PATH.ACTIVITY_FORM_QUIZ_PREVIEW_NO_LOGIN}
          element={<ActivityFormCusPreviewContainer />}
        />
        <Route
          path={ROUTE_PATH.ACTIVITY_FORM_QUIZ_THANK_YOU_NO_LOGIN}
          element={<ActivityFormThankContainer />}
        />
      </Route>
      <Route element={<Mainlayouts.PageLayout />}>
        <Route
          path={ROUTE_PATH.CERIFICATE_DETAIL}
          element={<CetificateLandingContainer />}
        />
        <Route
          path={ROUTE_PATH.PRE_REGISTER}
          element={<PreRegisterContainer />}
        />
        <Route
          path={ROUTE_PATH.NOTIFICATION}
          element={<PreLineAuthProductWarrantyContainer />}
        />
        <Route path={ROUTE_PATH.PDPA} element={<PDPAContainer />} />
        <Route
          path={ROUTE_PATH.LOGIN_ADMIN}
          element={<LoginAdminContainer />}
        />
        <Route
          path={ROUTE_PATH.ACTIVITIES_ADMIN_SCAN}
          element={<AdminScanActivityContainer />}
        />
        <Route
          path={ROUTE_PATH.ACTIVITIES_DETAIL_PREVIEW}
          element={<ActivitiesDetailPreviewContainer />}
        />
        <Route
          path={ROUTE_PATH.ACTIVITIES_FORM_PREVIEW_DETAIL}
          element={<ActivityFormAdminPreviewContainer />}
        />
        <Route
          path={ROUTE_PATH.PRODUCT_WARRANTEE_NOT_LOGIN_DETAIL}
          element={<ProductwarranteeNotLoginContainer />}
        />
        <Route
          path={ROUTE_PATH.PRODUCT_WARRANTEE_SUCCESS_NOT_LOGIN}
          element={<ProductWarranteeNotLoginSuccessContainer />}
        />
      </Route>
      <Route path={ROUTE_PATH.SYSTEM} element={<Mainlayouts.SystemLayout />}>
        {systemRoutes &&
          systemRoutes.map((e, i) => {
            return !e.children ? (
              <Route
                key={i}
                index={e.index}
                path={e.path}
                element={e.element}
              />
            ) : (
              <Route key={i} path={e.path} element={e.element}>
                {e.children &&
                  e.children.map((f, j) => (
                    <Route
                      key={j}
                      // index={f.index}
                      index
                      path={f.path}
                      element={f.element}
                    />
                  ))}
              </Route>
            );
          })}
      </Route>
    </Routes>
  );
};

export default Navigations;
